import { render, staticRenderFns } from "./bookmakercomparison.vue?vue&type=template&id=ddb16f7c&scoped=true"
import script from "./bookmakercomparison.vue?vue&type=script&lang=js"
export * from "./bookmakercomparison.vue?vue&type=script&lang=js"
import style0 from "./bookmakercomparison.vue?vue&type=style&index=0&id=ddb16f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb16f7c",
  null
  
)

export default component.exports